import Select from "react-select";
import { loadingIndicator } from "./../../../shared";

const selectComponents = {
  IndicatorSeparator: () => null,
  LoadingIndicator: (props) => loadingIndicator(props),
};

export const SelectComponent = ({
  name,
  isMulti = false,
  value,
  options,
  onChange,
  placeholder,
  styles,
  isLoading,
  isDisabled,
  className = "w-100 font-14-px text-secondary",
  ...otherProps
}) => {
  return (
    <Select
      isMulti={isMulti}
      {...otherProps}
      name={name}
      value={value}
      options={options}
      components={selectComponents}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.name}
      onChange={onChange}
      placeholder={placeholder}
      isSearchable={true}
      styles={styles}
      className={className}
      data-testid={`${name}-field`}
      isLoading={isLoading}
      isDisabled={isDisabled}
    />
  );
};
